import $ from 'jquery/src/jquery';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { SplitText } from "gsap/dist/SplitText";

import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase)
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

export default () => {
    const nodeSelectors = {
        item: '[js-animation-text="item"]',
    }

    function init() {
        /**
         * Global animation for main titles
         **/
            // Get all titles elements
        const mainTitleAnimationEl = $(nodeSelectors.item)

        if( mainTitleAnimationEl.length ) {
            let titleSplitChar = new SplitText(mainTitleAnimationEl, {
                type: "chars",
                charsClass: "char",
            });

            // Foreach title create timeline animation
            mainTitleAnimationEl.each(function(){
                let tl = gsap.timeline({defaults: {duration: 0.9}})

                // tl.to($(this), {opacity: 1, duration: 0.9})
                tl.to($(this).find('.char'), {
                    opacity: 1,
                    stagger: 0.02,
                    ease: CustomEase.create("custom", "M0,0 C0,0.408 0.257,0.854 0.31,0.906 0.361,0.957 0.584,1 1,1 ")
                },0)

                ScrollTrigger.create({
                    animation: tl,
                    trigger: $(this),
                    markers: false,
                    start: "top 70%",
                    // end: "bottom 70%",
                    // scrub: 0
                });
            })
        }
        /**
         * Global animation for main titles END
         **/
    }

    return Object.freeze({
        init,
    })
}
